import First from "../../../../../assets/images/project/interior/MAF_SD/interior-maf-sd-thumb.jpg";

export default [
  {
    title: "MAF SD",
    description: "",
    urls: First,
  },
];
